import { MiddlewareAPI, Middleware } from '@reduxjs/toolkit'
import dayjs from 'dayjs';
import i18n from 'i18n';
// Models
import { AppDispatch } from 'app/store';
import { ISubscription } from 'app/store/Subscriptions/Subscriptions.models';
// Types
import { SubscriptionStatus } from 'app/store/Subscriptions/Subscriptions.types';
// Async
import { getSubscriptions } from 'app/store/BillingSubscriptions/BillingSubscriptions.async';
// Actions
import { AppUiNotificationsActions } from 'app/store/AppUINotifications/AppUINotifications.slice';

const BillingSubscriptionsMiddleware:Middleware = ({ dispatch }:MiddlewareAPI<AppDispatch>) => (next:any) => (action:any) => {
  const { type, payload } = action;

  if ( type === getSubscriptions.fulfilled.type ){
    const subscriptions = payload as ISubscription[];

    const trialingSubscription = subscriptions.find(sub => sub.status === SubscriptionStatus.Trialing);

    if ( trialingSubscription ){
      const daysLeft = dayjs(trialingSubscription.trialPeriodEnd).diff(dayjs(), 'day') + 1; // +1 to include the current day
      dispatch(AppUiNotificationsActions.addSystemMessage({
        type: 'message',
        message: i18n.t('notifications.billingSubscriptionsMiddleware.trialEnds', { days: daysLeft }),
        forceShow: true
      }));
    }
  }

  return next(action);
}

export default BillingSubscriptionsMiddleware;
